import { render } from "./interests.vue?vue&type=template&id=a11b29ee&ts=true"
import script from "./interests.vue?vue&type=script&lang=ts"
export * from "./interests.vue?vue&type=script&lang=ts"

import "./interests.vue?vue&type=style&index=0&id=a11b29ee&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])